import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const FilledTemplateNotice: React.FC = () => {
	return (
		<div
			data-qa="update-supporters-filled-template-notice"
			className="bg-background-raised mt-8 flex flex-col gap-4 rounded-lg p-4 leading-6"
		>
			<Text as="p" fontWeight="bold">
				<Translate value="corgi.petition_update.pre_filled_form_notice.header" />
			</Text>
			<Text as="p">
				<Translate value="corgi.petition_update.pre_filled_form_notice.description" />
			</Text>
		</div>
	);
};
